import React, { useState } from "react";
import {
  Banknote,
  CalendarDays,
  Camera,
  CheckCircle2,
  ChevronRight,
  CircleUserRound,
  ClipboardList,
  LogOut,
  Menu,
  Settings,
  ShieldCheck,
  Trophy,
  Trash2,
  WalletCards,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios";
import { useUser } from "../../../hooks/use-user";
import DemoUser from "../../../Images/demoUserForNavbar.jpg";
import BottomNavbar from "./BottomNavbar";

const Profile = () => {
  const { data: user } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const solvedQuestions =
    user?.totalSolveQue || user?.totalSolvedQuestions || user?.questionsSolved || 1000;
  const joinedContests =
    user?.joinContest || user?.joinedContest || user?.contestCount || "02";

  const handleDeleteAccount = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      await axios.delete("/users/me", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      localStorage.removeItem("token");
      window.location.href = "/login";
    } catch (err) {
      alert("Failed to delete account");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const menuItems = [
    {
      icon: CircleUserRound,
      title: "Personal Information",
      subtitle: "Manage name, email & Phone",
      iconClass: "text-bgBlue",
      bgClass: "bg-[#D9CEE8]",
    },
    {
      icon: ShieldCheck,
      title: "KYC Status",
      subtitle: user?.isKycVerified ? "Verified" : "Verification pending",
      iconClass: "text-[#23A455]",
      bgClass: "bg-[#D9CEE8]",
      verified: user?.isKycVerified,
    },
    {
      icon: Banknote,
      title: "Bank Setting",
      subtitle: "Manage withdrawal Account",
      iconClass: "text-bgBlue",
      bgClass: "bg-[#D9CEE8]",
    },
    {
      icon: ShieldCheck,
      title: "Security",
      subtitle: "Login History",
      iconClass: "text-bgBlue",
      bgClass: "bg-[#D9CEE8]",
    },
  ];

  const upcomingContests = [
    {
      title: "Maths Champions League",
      meta: "25 May 2024  •  10:00 AM",
    },
    {
      title: "Science Quiz Battle",
      meta: "28 May 2024  •  02:00 PM",
    },
  ];

  const recentActivity = [
    {
      icon: CheckCircle2,
      title: "KYC verified successfully",
      time: "20 May 2024, 11:30 AM",
      iconClass: "text-[#23A455] bg-[#EAF8EF]",
    },
    {
      icon: WalletCards,
      title: "Withdrawal request submitted",
      time: "18 May 2024, 04:15 PM",
      iconClass: "text-bgBlue bg-[#EEE6F6]",
    },
    {
      icon: ShieldCheck,
      title: "Password changed successfully",
      time: "15 May 2024, 09:20 AM",
      iconClass: "text-bgBlue bg-[#EEE6F6]",
    },
  ];

  return (
    <div className="min-h-screen bg-[#F7F6FA] font-poppins pb-24 lg:pb-10">
      <div className="hidden lg:block">
        <div className="mx-auto w-full max-w-7xl px-0 py-6">
          <section className="relative rounded-[30px] bg-bgBlue px-12 py-10 text-white shadow-xl">
            <div className="h-36 w-36 rounded-full bg-[radial-gradient(circle,_rgba(255,255,255,0.26)_1px,_transparent_1px)] [background-size:10px_10px] opacity-50" />
            <div className="top-6 h-48 w-48 rounded-full border border-white/10 shadow-[0_0_0_10px_rgba(255,255,255,0.03),0_0_0_22px_rgba(255,255,255,0.025),0_0_0_36px_rgba(255,255,255,0.02)]" />
            <div className="relative z-10 flex items-center justify-between gap-8">
              <div className="flex items-center gap-8">
                <div className="relative">
                  <div className="h-32 w-32 rounded-full border-[5px] border-[#FFF2D9] p-1">
                    <img
                      src={user?.profilePicUrl || DemoUser}
                      alt="profile"
                      className="h-full w-full rounded-full object-cover"
                    />
                  </div>
                  <button
                    className="absolute bottom-2 right-0 flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-secondary text-white"
                    aria-label="Edit profile photo"
                  >
                    <Camera size={17} />
                  </button>
                </div>

                <div>
                  <h1 className="text-3xl font-bold">
                    {user?.name || "Ajay Tayde"}
                  </h1>
                  <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-white/20 px-4 py-1.5 text-xs font-medium text-white">
                    <span className="h-2 w-2 rounded-full bg-white" />
                    Active Courses
                  </div>
                </div>
              </div>

              <div className="grid w-full max-w-2xl grid-cols-2 gap-5">
                <div className="flex items-center gap-5 rounded-xl bg-[#FFF4DC] px-7 py-6 text-bgBlue shadow-lg">
                  <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-[#EEE6F6] text-bgBlue">
                    <ClipboardList size={26} />
                  </span>
                  <div>
                    <p className="text-xs font-semibold">Total Solve Question</p>
                    <p className="mt-2 text-3xl font-black">{solvedQuestions}</p>
                  </div>
                </div>

                <div className="flex items-center gap-5 rounded-xl bg-[#FFF4DC] px-7 py-6 text-bgBlue shadow-lg">
                  <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-[#EEE6F6] text-bgBlue">
                    <Trophy size={26} />
                  </span>
                  <div>
                    <p className="text-xs font-semibold">Join Contest</p>
                    <p className="mt-2 text-3xl font-black">{joinedContests}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-12 left-1/2 h-20 w-[120%] -translate-x-1/2 rounded-[50%] bg-[#F7F6FA]" />
          </section>

          <div className="mt-10 grid grid-cols-[1fr_420px] gap-10">
            <section>
              <h2 className="text-lg font-bold text-[#251936]">Quick Access</h2>
              <div className="mt-4 grid grid-cols-2 gap-5">
                {menuItems.map((item) => {
                  const Icon = item.icon;

                  return (
                    <button
                      key={item.title}
                      className="flex min-h-[132px] items-center gap-5 rounded-xl bg-white p-6 text-left shadow-sm ring-1 ring-bgBlue/5 transition hover:-translate-y-0.5 hover:shadow-md"
                    >
                      <span
                        className={`flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-lg ${item.bgClass} ${item.iconClass}`}
                      >
                        <Icon size={30} />
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-base font-semibold text-[#251936]">
                          {item.title}
                        </span>
                        <span className="mt-2 flex items-center gap-1 text-xs text-[#5C5367]">
                          {item.verified && (
                            <CheckCircle2 size={14} className="text-[#23A455]" />
                          )}
                          {item.subtitle}
                        </span>
                      </span>
                      <ChevronRight size={20} className="text-[#251936]" />
                    </button>
                  );
                })}
              </div>

              <div className="mt-6 flex gap-4">
                <button
                  onClick={handleLogout}
                  className="flex items-center justify-center gap-2 rounded-xl bg-bgBlue px-5 py-3 text-sm font-semibold text-white shadow-sm"
                >
                  <LogOut size={17} />
                  Logout
                </button>
                <button
                  onClick={handleDeleteAccount}
                  disabled={loading}
                  className="flex items-center justify-center gap-2 rounded-xl bg-red-600 px-5 py-3 text-sm font-semibold text-white shadow-sm disabled:opacity-60"
                >
                  <Trash2 size={17} />
                  {loading ? "Deleting" : "Delete Account"}
                </button>
              </div>
            </section>

            <aside className="space-y-7">
              <section>
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-bold text-[#251936]">
                    Upcoming Contests
                  </h2>
                  <button className="text-xs font-semibold text-bgBlue">View All</button>
                </div>

                <div className="mt-4 overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-bgBlue/5">
                  {upcomingContests.map((contest) => (
                    <div
                      key={contest.title}
                      className="flex items-center gap-4 border-b border-bgBlue/10 p-4 last:border-b-0"
                    >
                      <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#EEE6F6] text-bgBlue">
                        <Trophy size={22} />
                      </span>
                      <div className="min-w-0 flex-1">
                        <p className="text-sm font-semibold text-[#251936]">
                          {contest.title}
                        </p>
                        <p className="mt-1 flex items-center gap-1 text-[11px] text-[#5C5367]">
                          <CalendarDays size={12} />
                          {contest.meta}
                        </p>
                      </div>
                      <button className="rounded-md border border-bgBlue/40 px-4 py-2 text-xs font-semibold text-bgBlue">
                        Join Now
                      </button>
                    </div>
                  ))}
                </div>
              </section>

              <section>
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-bold text-[#251936]">
                    Recent Activity
                  </h2>
                  <button className="text-xs font-semibold text-bgBlue">View All</button>
                </div>

                <div className="mt-4 overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-bgBlue/5">
                  {recentActivity.map((activity) => {
                    const Icon = activity.icon;

                    return (
                      <div
                        key={activity.title}
                        className="flex items-center gap-4 border-b border-bgBlue/10 p-4 last:border-b-0"
                      >
                        <span
                          className={`flex h-10 w-10 items-center justify-center rounded-full ${activity.iconClass}`}
                        >
                          <Icon size={18} />
                        </span>
                        <p className="min-w-0 flex-1 text-sm font-semibold text-[#251936]">
                          {activity.title}
                        </p>
                        <p className="text-[11px] text-[#5C5367]">
                          {activity.time}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </section>
            </aside>
          </div>
        </div>
      </div>

      <div className="mx-auto min-h-screen w-full max-w-md bg-[#F7F6FA] shadow-xl lg:hidden">
        <section className="relative h-[405px] overflow-hidden bg-bgBlue px-3 pt-12 text-white">
          <div className="relative z-10 flex items-center justify-between">
            <button
              onClick={() => navigate("/dash")}
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/25 bg-white/5 text-white shadow-inner"
              aria-label="Back to dashboard"
            >
              <Menu size={22} />
            </button>

            <div className="flex items-center gap-4">
              <button
                className="flex h-12 w-12 items-center justify-center rounded-full border border-white/25 bg-white/5 text-white shadow-inner"
                aria-label="Wallet"
              >
                <WalletCards size={21} />
              </button>
              <button
                className="flex h-12 w-12 items-center justify-center rounded-full border border-white/25 bg-white/5 text-white shadow-inner"
                aria-label="Settings"
              >
                <Settings size={21} />
              </button>
            </div>
          </div>

          <div className="relative z-10 mt-12 flex flex-col items-center">
            <div className="relative">
              <div className="h-[118px] w-[118px] rounded-full border-[5px] border-[#FFF2D9] p-1">
                <img
                  src={user?.profilePicUrl || DemoUser}
                  alt="profile"
                  className="h-full w-full rounded-full object-cover"
                />
              </div>
              <button
                className="absolute bottom-2 right-0 flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-secondary text-white"
                aria-label="Edit profile photo"
              >
                <Camera size={17} />
              </button>
            </div>

            <h1 className="mt-4 text-[16px] font-bold">
              {user?.name || "Ajay Tayde"}
            </h1>
            <div className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-[#EEE6F6] px-3 py-1.5 text-xs font-medium text-[#22152F]">
              <span className="h-2 w-2 rounded-full bg-secondary" />
              Active Courses
            </div>
          </div>

          <div className="absolute -bottom-10 left-1/2 h-24 w-[130%] -translate-x-1/2 rounded-[50%] bg-[#F7F6FA]" />
        </section>

        <section className="relative z-20 -mt-[74px] px-3">
          <div className="grid grid-cols-2 gap-2">
            <div className="rounded-xl border border-bgBlue/40 bg-[#FFF4DC] px-3 py-3 text-center shadow-sm">
              <p className="text-xs font-medium text-bgBlue">Total Solve Que</p>
              <p className="mt-2 text-2xl font-black leading-none text-bgBlue">
                {solvedQuestions}
              </p>
            </div>
            <div className="rounded-xl border border-bgBlue/40 bg-[#FFF4DC] px-3 py-3 text-center shadow-sm">
              <p className="text-xs font-medium text-bgBlue">Join Contest</p>
              <p className="mt-2 text-2xl font-black leading-none text-bgBlue">
                {joinedContests}
              </p>
            </div>
          </div>
        </section>

        <section className="mt-5 space-y-3 px-3">
          {menuItems.map((item) => {
            const Icon = item.icon;

            return (
              <button
                key={item.title}
                className="flex min-h-[56px] w-full items-center gap-3 rounded-xl border border-bgBlue/20 bg-[#EEEAF4] p-2 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
              >
                <span
                  className={`flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg ${item.bgClass} ${item.iconClass}`}
                >
                  <Icon size={22} />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-[15px] font-medium text-[#251936]">
                    {item.title}
                  </span>
                  <span className="mt-1 flex items-center gap-1 text-[10px] text-[#5C5367]">
                    {item.verified && (
                      <CheckCircle2 size={13} className="text-[#23A455]" />
                    )}
                    {item.subtitle}
                  </span>
                </span>
                <ChevronRight size={18} className="text-bgBlue/50" />
              </button>
            );
          })}

          <div className="hidden grid-cols-2 gap-3 pt-2">
            <button
              onClick={handleLogout}
              className="flex items-center justify-center gap-2 rounded-xl bg-bgBlue px-4 py-3 text-sm font-semibold text-white shadow-sm"
            >
              <LogOut size={17} />
              Logout
            </button>
            <button
              onClick={handleDeleteAccount}
              disabled={loading}
              className="flex items-center justify-center gap-2 rounded-xl bg-red-600 px-4 py-3 text-sm font-semibold text-white shadow-sm disabled:opacity-60"
            >
              <Trash2 size={17} />
              {loading ? "Deleting" : "Delete"}
            </button>
          </div>
        </section>
      </div>

      <BottomNavbar />
    </div>
  );
};

export default Profile;
